import React from "react";
import NotificationMail from "./notification_mail";
import NotificationMessenger from "./notification_messenger";

function Notifications(props) {
  return (
    <div className='container'>
      <div className='row d-flex justify-content-center no-gutter'>
        <div className='col-11 col-lg-10 py-4'>
          <h2>お知らせの設定</h2>
          <div className='form-group row'>
            <div className='col-6 col-md-8'>
              <label className='col-form-label form-control-label' htmlFor='message'>メッセージ</label>
              <p>あなた宛のメッセージがあったときに通知されます。</p>
            </div>
            <NotificationMail {...props} />
            <NotificationMessenger {...props} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Notifications;
